export default "__VITE_ASSET__BA2ALxgs__"